var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M10 1L8.15385 2.84615L14.3077 9L8.15385 15.1538L10 17L18 9L10 1Z"}}),_c('path',{attrs:{"d":"M3.84615 1L2 2.84616L8.15384 9L2 15.1538L3.84615 17L11.8462 9L3.84615 1Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }